<!--
 * @Description:  满足checkNeedUserTag 函数才会显示这个组件 ，比较残暴的一种方式
 * @Date: 2022-03-02 18:06:18
-->
<template>
  <div>
    <el-form-item
      :label="label"
      :prop="prop"
      v-if="$checkNeedUserTag($store.state.homeProject)"
    >
      <el-select
        ref="personLabelSelect"
        v-model="dataObj[prop]"
        filterable
        allow-create
        default-first-option
        :style="customStyle"
        :placeholder="placeholder"
        clearable
        @change="handleChange"
      >
        <el-option
          v-for="item in options"
          :key="item.user_tag"
          :label="item.user_tag"
          :value="item.user_tag"
        ></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import { projectPersonnelManagement } from '@/api/ajax';
export default {
  name: 'person-label',
  props: {
    label: {
      type: String,
      default: '人员标签：'
    },
    prop: {
      type: String,
      default: 'userTag'
    },
    placeholder: {
      type: String,
      default: '请输入人员标签'
    },
    maxLength: {
      type: Number,
      default: 10
    },
    customStyle: {
      type: String,
      default: 'width:230px'
    },
    dataObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      options: []
    };
  },
  methods: {
    handleChange(changeValue) {
      const { dataObj, prop, options, $xrkDialog } = this;
      const _changeValue = `${changeValue}`.replace(/,/g, '');
      const isNewPersonLabel =
        _changeValue.length > 0 &&
        options.findIndex(({ user_tag }) => user_tag === _changeValue) === -1;

      // 将输入内容去除掉英文的逗号
      dataObj[prop] = _changeValue;

      if (isNewPersonLabel) {
        // 是新标签
        $xrkDialog({
          width: '400px',
          'show-close': false,
          success(params) {
            if (!params.confirm) {
              dataObj[prop] = '';
            }
            params.dialog.remove();
          },
          $slots: {
            default: (
              <div style="font-size: 16px;text-align: center;">
                <p>
                  您添加的“<span style={{ color: '#f00' }}>{_changeValue}</span>
                  ”标签为本项目首次创建
                </p>
                <p style="margin-top: 10px;">请确认是否正确</p>
              </div>
            )
          }
        });
      }
    }
  },
  created() {
    projectPersonnelManagement
      .listPersonTagForSelect({
        projectId: this.$store.state.homeProject.id
      })
      .then(
        ({
          data: {
            data: { list }
          }
        }) => {
          this.options = list;
        }
      );
    if (!this.$checkNeedUserTag(this.$store.state.homeProject)) {
      console.warn('不符合显示人员标签功能的条件，所以personLabel组件不显示');
    }
  },
  mounted() {
    /**
     * 设置最长输入长度
     */
    const personLabelSelectRef = this.$refs['personLabelSelect'];
    const inputDOM = personLabelSelectRef.$el.querySelector('.el-input__inner');
    inputDOM.setAttribute('maxLength', this.maxLength);
  }
};
</script>
<style lang="scss" scoped></style>
